import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    follow: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: 8,
      padding: '14px 19px',
      height: 54,
      '& button': {
        backgroundColor: '#0B77D8',
        fontWeight: 'bold',
        color: theme.palette.primary.contrastText,
        padding: '6px 14px',
        border: 'none',
        borderRadius: 5,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.palette.info.main,
        },
      },
    },

    followText: {
      margin: '0 24px 0 15px',
      fontSize: 12,

      display: 'flex',
      flexDirection: 'column',

      lineHeight: 1.5,
      '& strong': {
        fontSize: 14,
      },
    },
  }),
);

export default useStyles;
